// A bare, non-paginated array: at most "agences × (types du compte)" rows, sorted server-side by
// `facility.id` then by document type (system types first, then free types by label). `documentType`
// is a relation, always `{ id }`: the label is resolved client-side via
// `DocumentTypesListView.labelOf`.
export type FacilityTemplateOverridePayload = {
	readonly id: number;
	readonly facility: { readonly id: number };
	readonly documentType: { readonly id: number };
	readonly template: { readonly id: number };
};

export type FacilityTemplateOverridesFetchedPayload = FacilityTemplateOverridePayload[];

export type FacilityTemplateOverridesFetchedAction = {
	type: 'FACILITY_TEMPLATE_OVERRIDES_FETCHED';
	payload: FacilityTemplateOverridesFetchedPayload;
	organizationId: number;
};

export default (
	payload: FacilityTemplateOverridesFetchedPayload,
	organizationId: number,
): FacilityTemplateOverridesFetchedAction => ({
	type: 'FACILITY_TEMPLATE_OVERRIDES_FETCHED',
	payload,
	organizationId,
});
